import { render, staticRenderFns } from "./bill_details.vue?vue&type=template&id=59a4b036&scoped=true&"
import script from "./bill_details.vue?vue&type=script&lang=js&"
export * from "./bill_details.vue?vue&type=script&lang=js&"
import style0 from "./bill_details.vue?vue&type=style&index=0&id=59a4b036&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a4b036",
  null
  
)

export default component.exports